import React from "react";
import {baseUrl, translate} from "@mediaspace/shared/utils";
import {StatusScreen} from "@mediaspace/shared/ui";
import { useScript } from "@mediaspace/hooks";
import MailIllustration from "@mediaspace/shared/ui/styled-illustration/MailIllustration";
import { RegistrationType } from "./SiteRegistrationProps";

export interface Props {
    registrationType: RegistrationType;
    completeTitle: string;
    completeDescriptionHtml: string;
    completeButtonText?: string;
    completeButtonUrl?: string;
    onCompleteScriptContent?: string;
}

/**
 * Site registration complete/updated screen
 */
const RegistrationComplete: React.FC<Props> = ({
    registrationType = RegistrationType.NEW,
    completeTitle,
    completeDescriptionHtml,
    completeButtonText,
    completeButtonUrl,
    onCompleteScriptContent,
}) => {

    useScript(onCompleteScriptContent);
    return (
        <>
        {registrationType !== RegistrationType.EDIT && (
            <StatusScreen
                className={"kms-ds-site-registration-complete"}
                contentWidth={584}
                title={completeTitle}
                text={completeDescriptionHtml}
                buttonLabel={completeButtonText}
                buttonProps={{
                    href: completeButtonUrl,
                    rel: "noreferrer"
                }}
                image={MailIllustration}
            />

        )}
        {registrationType === RegistrationType.EDIT && (
            <StatusScreen
                className={"kms-ds-site-registration-complete"}
                contentWidth={584}
                title={translate("Details updated successfully")}
                text={translate("Your details have been successfully updated")}
                buttonLabel={translate("Go To Profile")}
                buttonProps={{
                    href: `${baseUrl}/profile`,
                }}
            />
        )}
        </>
    )
};

export default RegistrationComplete;
